export default __webpack_public_path__ + "static/media/TorpedoOpen.e1b5c84f.jpg";